export default "__VITE_ASSET__CxW_rQ4l__"